// TODO: make env specific
import { config } from '../config';

const urls = {
  getPrompts: `${config.HTTP_API_URL}/prompts`, //GET
  updatePrompts: `${config.HTTP_API_URL}/prompts`, //POST
};

export const server = {
  getPrompts: async (accessToken) =>
    fetch(urls.getPrompts, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    }),
  updatePrompts: async (accessToken, configs) =>
    fetch(urls.updatePrompts, {
      method: 'POST',
      body: JSON.stringify(configs),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    }),
};
